import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import accountStoreModule from '@/views/modules/account-setting/accountStoreModule'
import useHelpers from '@/views/modules/useHelpers'
import axios from '@/libs/axios'
//import axios from 'axios'
 


export default function useAccountSettings (root) {

   


   // const ACCOUNT_APP_STORE_MODULE_NAME = 'account-settings'

const NotificationsList=ref([]);
  const   getList=() =>{
    return new Promise((resolve, reject) => {
      axios.get(`user/getEventNotifications`)
    //  axios.get(`https://jsonplaceholder.typicode.com/todos`)
        .then(res =>{ 
          //console.log(res.data.notifications)
          resolve(NotificationsList.value=res.data.notifications)
        })
        .catch(reason => reject(reason.response))
    })
  }
  const   postNotificationSetting=(data) =>{
    return new Promise((resolve, reject) => {
     // axios.get(`user/getEventNotifications`)
      axios.post(`user/setEventNotifications`,data)
        .then(res => {
          resolve(res.data)
          toaster('Notifications Updated Successfully')
        })
        .catch(reason => reject(reason.response))
    })
  }

  getList();
   
   const ACCOUNT_APP_STORE_MODULE_NAME = 'account-settings'

    // Register module
    if (!store.hasModule(ACCOUNT_APP_STORE_MODULE_NAME))
      store.registerModule(ACCOUNT_APP_STORE_MODULE_NAME, accountStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ACCOUNT_APP_STORE_MODULE_NAME))
        store.unregisterModule(ACCOUNT_APP_STORE_MODULE_NAME)
    })

   const accountData = ref(null)
   const requestStatus = ref(null)

   store.dispatch('account-settings/getProfileData').then(res => accountData.value = res.data)
    .catch(reason => {})


  const { toaster } = useHelpers(root)


  const errors = ref({})

  const  profilePost =  () => {

    errors.value = {}
    requestStatus.value = true
    store.dispatch('account-settings/postProfileData',
      { data: accountData.value }).then(r => {
      requestStatus.value = false
      toaster('Profile Data Updated Successfully')
      store.commit('auth/SET_AUTH_NAME_EMAIL_AVATAR', accountData.value)})
      .catch(reason =>  {
        requestStatus.value = false
        errors.value = reason.response.data
      })

  }


  const passwordPost = (data) => {
    errors.value = {}
    requestStatus.value = true
    store.dispatch('account-settings/postPassword',
      { data: data }).then(r => {
      requestStatus.value = false
      toaster('Password Updated Successfully')})
      .catch(reason => {
        requestStatus.value = false
        errors.value = reason.response.data
      })
  }



  return {
    accountData,
    requestStatus,
    profilePost,
    passwordPost,
    errors,

   
    getList,
    NotificationsList,
    postNotificationSetting
  }

}
